import styled from 'styled-components';

export default styled.div`
	margin: 0 -20px;
`;
